{
	"meta": {
		"title": "UpSquad — Tu app de comunidad con marca propia, en 72 horas",
		"description": "UpSquad da a tu organización una comunidad de aprendizaje y networking impulsada por IA — con una app móvil con tu marca, lista en la App Store en 72 horas."
	},
	"hero": {
		"eyebrow": "Del registro a la App Store en 72 horas",
		"title_1": "Tu comunidad.",
		"title_2": "Tu app con marca.",
		"title_3": "Lista en 72 horas.",
		"subtitle": "Lanza una comunidad de aprendizaje y networking con IA que sí ayuda — bajo tu marca y dominio. Sin desarrolladores. Sin agencias. Sin tirar código pegamento.",
		"cta_primary": "Crear cuenta gratis",
		"cta_secondary": "Reservar una demo",
		"bullet_1": "Prueba gratuita de 14 días",
		"bullet_2": "Sin tarjeta de crédito",
		"bullet_3": "App móvil con tu marca en 72 horas",
		"frames": {
			"events": "Pestaña de eventos de la app móvil",
			"feed": "Feed principal de la app móvil",
			"clips": "Pestaña de clips de la comunidad en la app móvil"
		}
	},
	"trusted_by": {
		"eyebrow": "Organizaciones líderes en Estados Unidos confían en UpSquad"
	},
	"demo": {
		"eyebrow": "Demo interactiva",
		"title": "Haz clic.",
		"title_accent": "Es el producto real.",
		"subtitle": "Navega UpSquad como lo haría un miembro — feed, miembros, mensajería, reuniones, eventos, IA y ajustes. Sin registro previo.",
		"footnote": "Demo en vivo · Estás tocando componentes reales",
		"footnote_cta": "Pruébalo gratis",
		"live_badge": "Demo en vivo",
		"nav_label": "Navegación de la demo del producto",
		"tabs": {
			"home": {
				"label": "Inicio",
				"hint": "Posts, encuestas, vídeos — el feed de tu comunidad en un solo lugar."
			},
			"members": {
				"label": "Miembros",
				"hint": "Directorio buscable con última actividad, grupos y presencia."
			},
			"messages": {
				"label": "Mensajes",
				"hint": "Canales y mensajes directos sustituyen las herramientas dispersas."
			},
			"meetings": {
				"label": "Reuniones",
				"hint": "1:1 y reuniones de grupo, con agendas generadas por IA."
			},
			"events": {
				"label": "Eventos",
				"hint": "Eventos gratuitos o de pago con RSVP y registro de asistencia."
			},
			"ai": {
				"label": "Insights de IA",
				"hint": "Pregunta lo que quieras sobre tu comunidad y obtén una respuesta real."
			},
			"settings": {
				"label": "Comunidad",
				"hint": "Marca, color, identidad — cada pantalla se re-tinta en vivo."
			}
		}
	},
	"unified": {
		"eyebrow": "Impulsado por IA",
		"title": "Una plataforma.",
		"title_accent": "Todas tus herramientas, unificadas.",
		"subtitle": "Deja de hacer malabares con diez apps inconexas. UpSquad reúne mensajería, eventos, reuniones, aprendizaje y datos de miembros en un único hogar para tu comunidad.",
		"stat_1": {
			"title": "Reemplaza diez herramientas",
			"body": "Mensajería, eventos, reuniones, aprendizaje — todo nativo, todos los miembros en un solo lugar."
		},
		"stat_2": {
			"title": "IA que de verdad ayuda",
			"body": "Insights, matchmaking y resúmenes automáticos desde el día uno. Sin ingeniería de prompts."
		},
		"stat_3": {
			"title": "Una sola fuente de verdad",
			"body": "Datos de miembros, actividad y resultados — unificados, siempre vivos, listos para tu junta directiva."
		},
		"metrics": {
			"tools": {
				"label": "herramientas reemplazadas"
			},
			"ai": {
				"label": "asistentes de IA integrados"
			},
			"truth": {
				"label": "fuente de verdad"
			},
			"launch": {
				"title": "Setenta y dos horas hasta la App Store",
				"body": "Los clientes Premium reciben una app iOS y Android con su marca, enviada y publicada por nosotros.",
				"label": "horas para lanzar"
			},
			"brand": {
				"title": "Con tu marca",
				"body": "Tu logo, nombre, colores y dominio en cada pantalla. Los miembros ven a tu organización, no a nosotros.",
				"label": "con tu marca"
			}
		}
	},
	"branded": {
		"eyebrow": "Función Premium",
		"title_1": "Tu marca. Tu app.",
		"title_accent": "En la App Store en 72 horas.",
		"subtitle": "Los clientes Premium reciben una app de iOS y Android totalmente personalizada — lista en tres días. Elige un tema y observa cómo cada pantalla se re-tinta.",
		"theme_label": "Selector de tema en vivo",
		"frames": {
			"events": "Pantalla de eventos con tu marca, tema {{theme}}",
			"feed": "Vista previa de la app móvil con tu marca, tema {{theme}}",
			"members": "Pantalla de miembros con tu marca, tema {{theme}}"
		},
		"benefit_1": {
			"title": "Totalmente personalizada",
			"body": "Tu logo, nombre y colores en toda la app. Tus miembros te ven a ti, no a nosotros."
		},
		"benefit_2": {
			"title": "Lanzamiento en setenta y dos horas",
			"body": "Del registro a la publicación en la App Store — gestionamos cada paso del envío."
		},
		"benefit_3": {
			"title": "Actualizaciones automáticas",
			"body": "Las nuevas funciones llegan a tus miembros automáticamente. Cero desarrolladores, cero mantenimiento."
		},
		"cta": "Consigue tu app con marca"
	},
	"ai_insights": {
		"eyebrow": "Pregunta lo que quieras",
		"title": "Deja de adivinar.",
		"title_accent": "Empieza a saber.",
		"subtitle": "Cada semana, la IA de UpSquad analiza tu comunidad — quién se compromete, quién se aleja, qué eventos generaron más conexión y qué hacer a continuación.",
		"url": "cohort-hub.upsquad.us/ai",
		"frame": "Pantalla de AI Insights de la app web",
		"feature_1": {
			"title": "Reportes semanales de engagement",
			"body": "Llegan a tu inbox automáticamente — sin dashboards que pelear."
		},
		"feature_2": {
			"title": "Recomendaciones accionables",
			"body": "Pasos concretos para reactivar miembros en riesgo, con plantillas listas para enviar."
		},
		"feature_3": {
			"title": "Match AI",
			"body": "Conecta a los miembros que deberían reunirse según objetivos, actividad y resultados."
		}
	},
	"getting_started": {
		"eyebrow": "Empezar",
		"title": "Tu comunidad,",
		"title_accent": "lista en minutos.",
		"step_1": {
			"title": "Crea tu cuenta gratis",
			"body": "Crea tu cuenta de UpSquad y configura una comunidad con tu marca en menos de diez minutos."
		},
		"step_2": {
			"title": "Invita a tus miembros",
			"body": "Comparte tu enlace personalizado (tuorg.upsquad.us) y da la bienvenida a tu equipo en un clic."
		},
		"step_3": {
			"title": "Crece con IA",
			"body": "Deja que UpSquad descubra insights, conecte a los miembros adecuados y gestione tus programas — mientras tú te enfocas en las personas."
		}
	},
	"pricing_teaser": {
		"title": "Empieza gratis.",
		"title_accent": "Diseñado para crecer.",
		"subtitle": "Empieza gratis, sin tarjeta de crédito. Sube de plan cuando tu comunidad esté lista para crecer.",
		"free": {
			"name": "Gratis",
			"price": "$0",
			"body": "Hasta 25 miembros · Funciones básicas · Prueba de 14 días",
			"cta": "Empezar gratis",
			"features": [
				"Hasta 25 miembros",
				"Feed y DMs básicos",
				"URL de comunidad personalizada"
			]
		},
		"pro": {
			"name": "Pro",
			"price": "$9",
			"period": "/usuario/mes",
			"ribbon": "Más popular",
			"body": "Todo en Gratis + IA · miembros ilimitados · eventos de pago",
			"cta": "Probar Pro",
			"features": [
				"Miembros ilimitados",
				"AI Insights + Match AI",
				"Eventos de pago y analítica"
			]
		},
		"premium": {
			"name": "Premium",
			"price": "A medida",
			"body": "Todo en Pro + app móvil con tu marca en 72 horas",
			"cta": "Hablar con ventas",
			"features": [
				"App de iOS + Android con tu marca",
				"Onboarding dedicado",
				"SLA de uptime garantizado"
			]
		},
		"see_all": "Ver todos los planes"
	},
	"final_cta": {
		"title": "¿Listo para lanzar",
		"title_accent": "tu comunidad?",
		"body": "Únete a las organizaciones que ya operan sus programas con UpSquad. Empieza gratis — sube de plan cuando estés listo.",
		"cta_primary": "Crear cuenta gratis",
		"cta_secondary": "Reservar una demo",
		"footnote": "Sin tarjeta · 14 días gratis · Cancela cuando quieras"
	}
}
